import { useQuery } from "@apollo/react-hooks";
import { OC_GET_POLLING } from "oc/graphql";

export const useOcPolling = (polling = 0) => {
  const { data, loading, error } = useQuery(OC_GET_POLLING, {
    fetchPolicy: "cache-first",
  });

  let result = polling;

  if (data?.getPolling === false || loading === true) {
    result = 0;
  }

  if (error) {
    console.log({
      component: "usePolling",
      errorDescription:
        "Error occured when fetch data with OC_GET_POLLING query",
      error: error,
    });
  }

  return result;
};

export default useOcPolling;
